import { render, staticRenderFns } from "./discuss-config.vue?vue&type=template&id=4ffba19e"
import script from "./discuss-config.vue?vue&type=script&lang=js"
export * from "./discuss-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports